import {
  i
} from "./chunk.FAJKIEWS.js";

// src/components/icons/jb-print-icon/jb-print-icon.css.ts
var jb_print_icon_css_default = i`:host{display:inline-block;height:var(--icon-size, 18px);width:var(--icon-size, 18px)}svg{height:var(--icon-height, 18px);transition:var(--icon-transition, none);width:var(--icon-width, 18px)}`;

export {
  jb_print_icon_css_default
};
